export default __webpack_public_path__ + "static/ai_block-3d304b1f3e44a0be388b8dce3180a7b2.svg";